'use client';

import { useEffect } from 'react';
import { AuthStatus } from '../lib/constants';
import {
  useCustomRouter,
  usePathname,
  useSearchParams,
} from '../lib/navigation';
import { getRedirectUrl } from '../lib/utils';
import { useAuthStore } from '../store/auth-store-provider';

export function useAuthStatus() {
  const pathname = usePathname();

  const { status } = useAuthStore((state) => state);

  const isAuthenticated = status === AuthStatus.Authenticated;
  const { navigate } = useCustomRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isAuthenticated) {
      const { url, type } = getRedirectUrl(status, pathname, searchParams);
      if (type === 'internal' && url !== pathname) {
        navigate(url);
      } else if (type === 'external') {
        window.location.href = url;
      }
    }
  }, [isAuthenticated, pathname, navigate, searchParams]);

  return { status, isAuthenticated };
}
